export enum ProjectCardSize {
  SMALL = 200,
  MEDIUM = 300,
  LARGE = 400,
}

export const DEFAULT_PROJECT_CARD_SIZE = ProjectCardSize.MEDIUM;

export const PROJECT_CARD_SIZE_PREFERENCE_ORDER: ProjectCardSize[] = [
  ProjectCardSize.MEDIUM,
  ProjectCardSize.SMALL,
  ProjectCardSize.LARGE,
];
